module.exports = __webpack_public_path__ + "img/shaman.3e28c46c.png";